import { Loader2 } from "lucide-react";

import { cn } from "../../lib/utils.js";

export const Spinner = ({
  className,
  size = "md",
}: {
  className?: string;
  size?: "sm" | "md" | "lg";
}) => (
  <Loader2
    aria-hidden
    className={cn(
      "animate-spin text-muted-foreground",
      size === "sm" && "size-4",
      size === "md" && "size-5",
      size === "lg" && "size-8",
      className
    )}
  />
);

export const FullPageSpinner = () => (
  <div className="flex min-h-[40vh] items-center justify-center">
    <Spinner size="lg" />
  </div>
);
